import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/label-has-associated-control */
import "./scss/index.scss";
import React, { useState } from "react";
import ReactSVG from "react-svg";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import { Button } from "@components/atoms";
import { useDelivery } from "@saleor/sdk/";
import { InputSelect, TextField } from "@app/components/molecules";
import { ObligatoryFieldEnum, GatewayTypesEnum, UserRoleEnum } from "@globalTypes/globalTypes";
import { commonMessages, paymentMessages } from "@temp/intl";
import { handleChangeImage, slugify } from "@temp/core/utils";
import { AlertShowImage } from "..";

var closeWhite = require("../../images/closewhite.svg");

var cardOptions = [{
  id: "debit",
  name: React.createElement(FormattedMessage, commonMessages.debit)
}, {
  id: "credit",
  name: React.createElement(FormattedMessage, commonMessages.credit)
}];
export var AlertDeliveryDecision = function AlertDeliveryDecision(_ref) {
  var _paymentMethodOptions, _errors$, _obligatoryFielsData$, _obligatoryFielsData$2, _obligatoryFielsData$3;

  var arrived = _ref.arrived,
      availableMethodPayments = _ref.availableMethodPayments,
      currentMethodPayment = _ref.currentMethodPayment,
      manualTransferChannelName = _ref.manualTransferChannelName,
      delivered = _ref.delivered,
      obligatoryFields = _ref.obligatoryFields,
      orderId = _ref.orderId,
      setLoading = _ref.setLoading,
      hideModal = _ref.hideModal,
      tradeName = _ref.tradeName,
      updateOrderStatus = _ref.updateOrderStatus;
  var intl = useIntl();
  var navigate = useNavigate();

  var _useDelivery = useDelivery(),
      updateToArrived = _useDelivery.updateToArrived,
      updateToDelivered = _useDelivery.updateToDelivered;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      SetErrors = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      photoError = _useState4[0],
      setPhotoError = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      imageBlob = _useState6[0],
      setImageBlob = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showImage = _useState8[0],
      setShowImage = _useState8[1];

  var _useState9 = useState([{
    field: "",
    message: ""
  }]),
      _useState10 = _slicedToArray(_useState9, 2),
      errorsFields = _useState10[0],
      setErrorsFields = _useState10[1];

  var paymentMethodOptions = [{
    id: GatewayTypesEnum.DATAPHONE,
    name: intl.formatMessage(commonMessages.card)
  }, {
    id: GatewayTypesEnum.CASH,
    name: intl.formatMessage(commonMessages.cash)
  }, {
    id: GatewayTypesEnum.NEQUI,
    name: intl.formatMessage(commonMessages.nequi)
  }];

  var _useState11 = useState({
    id: currentMethodPayment,
    name: (_paymentMethodOptions = paymentMethodOptions.find(function (availableMethodPayment) {
      return availableMethodPayment.id === currentMethodPayment;
    })) === null || _paymentMethodOptions === void 0 ? void 0 : _paymentMethodOptions.name
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      paymentMethodState = _useState12[0],
      setPaymentMethodState = _useState12[1];

  var _useState13 = useState(cardOptions[0]),
      _useState14 = _slicedToArray(_useState13, 2),
      paymentCardTypeState = _useState14[0],
      setPaymentCardTypeState = _useState14[1];

  var _useState15 = useState(""),
      _useState16 = _slicedToArray(_useState15, 2),
      confirmationCodeState = _useState16[0],
      setConfirmationCodeState = _useState16[1];

  var obligatoryFielsData = obligatoryFields === null || obligatoryFields === void 0 ? void 0 : obligatoryFields.reduce(function (prevVal, currVal) {
    var dataToReturn = _objectSpread({}, prevVal);

    if ((currVal === null || currVal === void 0 ? void 0 : currVal.fieldName) && (currVal === null || currVal === void 0 ? void 0 : currVal.fieldName) !== "" && (currVal === null || currVal === void 0 ? void 0 : currVal.fieldName.toLowerCase()) === ObligatoryFieldEnum.PAYMENT_CONFIRMATION_CODE.toLowerCase() && (currVal === null || currVal === void 0 ? void 0 : currVal.role) === (UserRoleEnum === null || UserRoleEnum === void 0 ? void 0 : UserRoleEnum.DELIVERY_MAN)) {
      dataToReturn = _objectSpread(_objectSpread({}, prevVal), {}, {
        paymentConfirmationCode: currVal
      });
    } else if ((currVal === null || currVal === void 0 ? void 0 : currVal.fieldName) !== "" && (currVal === null || currVal === void 0 ? void 0 : currVal.fieldName.toLowerCase()) === ObligatoryFieldEnum.PAYMENT_CONFIRMATION_FILE.toLowerCase() && (currVal === null || currVal === void 0 ? void 0 : currVal.role) === (UserRoleEnum === null || UserRoleEnum === void 0 ? void 0 : UserRoleEnum.DELIVERY_MAN)) {
      dataToReturn = _objectSpread(_objectSpread({}, prevVal), {}, {
        paymentConfirmationFile: currVal
      });
    }

    return dataToReturn;
  }, {
    paymentConfirmationCode: "",
    paymentConfirmationFile: ""
  });
  var isLockedPaymentMethod = paymentMethodState.id === GatewayTypesEnum.ONLINE_CREDIBANCO || paymentMethodState.id === GatewayTypesEnum.MANUAL_TRANSFER;
  var lockedPaymentMethodLabel = React.useMemo(function () {
    if (paymentMethodState.id === GatewayTypesEnum.MANUAL_TRANSFER) {
      var transferLabel = intl.formatMessage(paymentMessages.manualTransfer);

      if (manualTransferChannelName) {
        return "".concat(transferLabel, " (").concat(manualTransferChannelName, ")");
      }

      return transferLabel;
    }

    if (paymentMethodState.id === GatewayTypesEnum.ONLINE_CREDIBANCO) {
      return intl.formatMessage(paymentMessages.onlineCredibanco);
    }

    return "";
  }, [intl, manualTransferChannelName, paymentMethodState.id]);
  var scaleButton = useSpring({
    config: {
      friction: 40,
      mass: 5,
      tension: 350
    },
    from: {
      scale: 1.1
    },
    loop: true,
    to: {
      scale: 1
    }
  });

  var handleUpdateToArrived = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            handleMutationUpdateToArrived(position);

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function (error) {
                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      handleMutationUpdateToArrived(undefined, "PERMISSION_DENIED");
                      break;

                    case error.POSITION_UNAVAILABLE:
                      handleMutationUpdateToArrived(undefined, "POSITION_UNAVAILABLE");
                      break;

                    case error.TIMEOUT:
                      handleMutationUpdateToArrived(undefined, "TIMEOUT");
                      break;

                    default:
                      handleMutationUpdateToArrived(undefined, "ERROR_UNKNOWN");
                  }
                }, {
                  enableHighAccuracy: true,
                  timeout: 7000
                });
              } else {
                handleMutationUpdateToArrived(undefined, "ERROR_UNKNOWN");
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpdateToArrived() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleMutationUpdateToArrived = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(position, reasonNoLocation) {
      var _position$coords, _position$coords2, _position$coords3;

      var _yield$updateToArrive, data, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.next = 3;
              return updateToArrived(orderId, {
                latitude: (position === null || position === void 0 ? void 0 : (_position$coords = position.coords) === null || _position$coords === void 0 ? void 0 : _position$coords.latitude) ? Number(position.coords.latitude.toFixed(5)) : null,
                longitude: (position === null || position === void 0 ? void 0 : (_position$coords2 = position.coords) === null || _position$coords2 === void 0 ? void 0 : _position$coords2.longitude) ? Number(position.coords.longitude.toFixed(5)) : null,
                accuracy: (position === null || position === void 0 ? void 0 : (_position$coords3 = position.coords) === null || _position$coords3 === void 0 ? void 0 : _position$coords3.accuracy) ? Number(position.coords.accuracy.toFixed(5)) : null,
                reasonNoLocation: reasonNoLocation || null
              });

            case 3:
              _yield$updateToArrive = _context3.sent;
              data = _yield$updateToArrive.data;
              dataError = _yield$updateToArrive.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setLoading(false);
                SetErrors(errors);
              } else {
                updateOrderStatus(data);
                setLoading(false);
                hideModal();
              }

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleMutationUpdateToArrived(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleUpdateToDelivered = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setLoading(true);

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(position) {
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            handleMutationUpdateToDelivered(position);

                          case 1:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x4) {
                    return _ref6.apply(this, arguments);
                  };
                }(), function (error) {
                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      handleMutationUpdateToDelivered(undefined, "PERMISSION_DENIED");
                      break;

                    case error.POSITION_UNAVAILABLE:
                      handleMutationUpdateToDelivered(undefined, "POSITION_UNAVAILABLE");
                      break;

                    case error.TIMEOUT:
                      handleMutationUpdateToDelivered(undefined, "TIMEOUT");
                      break;

                    default:
                      handleMutationUpdateToDelivered(undefined, "ERROR_UNKNOWN");
                  }
                }, {
                  enableHighAccuracy: true,
                  timeout: 7000
                });
              } else {
                handleMutationUpdateToDelivered(undefined, "ERROR_UNKNOWN");
              }

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleUpdateToDelivered() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleMutationUpdateToDelivered = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(position, reasonNoLocation) {
      var _availableMethodPayme, _position$coords4, _position$coords5, _position$coords6;

      var _yield$updateToDelive, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              setLoading(true);
              _context6.next = 3;
              return updateToDelivered(orderId, {
                paymentConfirmationCode: (paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id) === GatewayTypesEnum.DATAPHONE && (obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : obligatoryFielsData.paymentConfirmationCode) ? confirmationCodeState : null,
                paymentConfirmationFile: imageBlob,
                gateway: paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id,
                paymentCardType: (paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id) === GatewayTypesEnum.DATAPHONE ? paymentCardTypeState === null || paymentCardTypeState === void 0 ? void 0 : paymentCardTypeState.id : null,
                token: (_availableMethodPayme = availableMethodPayments.find(function (availableMethodPayment) {
                  return (availableMethodPayment === null || availableMethodPayment === void 0 ? void 0 : availableMethodPayment.id) === (paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id);
                })) === null || _availableMethodPayme === void 0 ? void 0 : _availableMethodPayme.name,
                latitude: (position === null || position === void 0 ? void 0 : (_position$coords4 = position.coords) === null || _position$coords4 === void 0 ? void 0 : _position$coords4.latitude) ? Number(position.coords.latitude.toFixed(5)) : null,
                longitude: (position === null || position === void 0 ? void 0 : (_position$coords5 = position.coords) === null || _position$coords5 === void 0 ? void 0 : _position$coords5.longitude) ? Number(position.coords.longitude.toFixed(5)) : null,
                accuracy: (position === null || position === void 0 ? void 0 : (_position$coords6 = position.coords) === null || _position$coords6 === void 0 ? void 0 : _position$coords6.accuracy) ? Number(position.coords.accuracy.toFixed(5)) : null,
                reasonNoLocation: reasonNoLocation || null
              });

            case 3:
              _yield$updateToDelive = _context6.sent;
              dataError = _yield$updateToDelive.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setLoading(false);
                SetErrors(errors);
              } else {
                hideModal();
                setLoading(false);
                navigate("/delivery");
              }

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleMutationUpdateToDelivered(_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();

  var affirmativeAnswer = function affirmativeAnswer() {
    if (arrived) {
      handleUpdateToArrived();
    } else if (delivered) {
      handleUpdateToDelivered();
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "showContainerDelivered",
    onClick: hideModal
  }), React.createElement("div", {
    className: "showContainerDelivered__data ".concat(delivered ? "showContainerDelivered__data--delivered" : "")
  }, React.createElement("div", {
    className: "showContainerDelivered__data__close"
  }, React.createElement("p", null, arrived && React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1797368935",
    defaultMessage: "In the place"
  }), delivered && React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1464199760",
    defaultMessage: "Delivered"
  })), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: hideModal
  })), React.createElement("div", {
    className: "showContainerDelivered__data__content  showContainerDelivered__data__content--amount showContainerDelivered__data__content--first showContainerDelivered__data__content--last"
  }, React.createElement("p", {
    className: "showContainerDelivered__data__content__question"
  }, arrived && React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1249982264",
    defaultMessage: "Did you get to the customer's address?"
  }), delivered && React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.834720540",
    defaultMessage: "Before marking the order as delivered, please confirm the payment method"
  })), errors && React.createElement("div", {
    className: "showContainerDelivered__data__content"
  }, React.createElement("p", null, (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.message)), delivered && isLockedPaymentMethod ? React.createElement(TextField, {
    name: "paymentMethod",
    label: intl.formatMessage(paymentMessages.paymentMethod),
    defaultValue: lockedPaymentMethodLabel,
    disabled: true
  }) : delivered && React.createElement(InputSelect, {
    label: intl.formatMessage(paymentMessages.paymentMethod),
    name: "paymentMethod",
    defaultValue: currentMethodPayment,
    options: availableMethodPayments === null || availableMethodPayments === void 0 ? void 0 : availableMethodPayments.filter(function (paymentMethod) {
      return paymentMethod.id !== GatewayTypesEnum.ONLINE_CREDIBANCO && paymentMethod.id !== GatewayTypesEnum.MANUAL_TRANSFER;
    }).map(function (paymentMethod) {
      var name = "";

      if (paymentMethod.id === GatewayTypesEnum.CASH) {
        name = intl.formatMessage(commonMessages.cash);
      } else if (paymentMethod.id === GatewayTypesEnum.DATAPHONE) {
        name = intl.formatMessage(commonMessages.card);
      } else if (paymentMethod.id === GatewayTypesEnum.NEQUI) {
        name = intl.formatMessage(commonMessages.nequi);
      }

      return {
        id: paymentMethod.id,
        name: name
      };
    }),
    value: paymentMethodState,
    onChange: function onChange(value) {
      setPaymentMethodState({
        id: value.id,
        name: value.name
      });
    },
    optionLabelKey: "name",
    optionValueKey: "id"
  }), delivered && paymentMethodState.id === GatewayTypesEnum.DATAPHONE && React.createElement(InputSelect, {
    label: intl.formatMessage(paymentMessages.cardType),
    name: "paymentCardType",
    defaultValue: cardOptions[0].id,
    options: cardOptions,
    value: paymentCardTypeState,
    onChange: function onChange(value) {
      setPaymentCardTypeState({
        id: value.id,
        name: value.name
      });
    },
    optionLabelKey: "name",
    optionValueKey: "id"
  }), delivered && paymentMethodState.id === GatewayTypesEnum.DATAPHONE && (obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : obligatoryFielsData.paymentConfirmationCode) && React.createElement(React.Fragment, null, React.createElement(TextField, {
    name: "confirmationCode",
    label: obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : (_obligatoryFielsData$ = obligatoryFielsData.paymentConfirmationCode) === null || _obligatoryFielsData$ === void 0 ? void 0 : _obligatoryFielsData$.fieldLabel,
    placeholder: obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : (_obligatoryFielsData$2 = obligatoryFielsData.paymentConfirmationCode) === null || _obligatoryFielsData$2 === void 0 ? void 0 : _obligatoryFielsData$2.fieldPlaceholder,
    value: confirmationCodeState,
    errors: errorsFields === null || errorsFields === void 0 ? void 0 : errorsFields.filter(function (error) {
      return error.field === ObligatoryFieldEnum.PAYMENT_CONFIRMATION_CODE && error;
    }),
    onChange: function onChange(e) {
      if ((errorsFields === null || errorsFields === void 0 ? void 0 : errorsFields.length) > 0 && e.target.value !== "") {
        setErrorsFields(errorsFields.filter(function (error) {
          return error.field !== ObligatoryFieldEnum.PAYMENT_CONFIRMATION_CODE;
        }));
      }

      setConfirmationCodeState(e.target.value);
    },
    autoComplete: "confirmationCode",
    textAreaInputLabel: true
  })), delivered && paymentMethodState.id === GatewayTypesEnum.DATAPHONE && (obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : obligatoryFielsData.paymentConfirmationFile) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "showContainerDelivered__data__content__image"
  }, React.createElement("p", null, obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : (_obligatoryFielsData$3 = obligatoryFielsData.paymentConfirmationFile) === null || _obligatoryFielsData$3 === void 0 ? void 0 : _obligatoryFielsData$3.fieldLabel), React.createElement("form", {
    className: "showContainerDelivered__data__content__image__label"
  }, React.createElement(React.Fragment, null, imageBlob ? React.createElement("div", {
    className: "showContainerDelivered__data__content__image__label__showImage"
  }, React.createElement("img", {
    alt: "",
    src: URL.createObjectURL(imageBlob),
    id: "showimage",
    onClick: function onClick() {
      return setShowImage(true);
    }
  }), React.createElement("div", null, React.createElement("div", {
    onClick: function onClick() {
      return setShowImage(true);
    },
    className: "showContainerDelivered__data__content__image__label__showImage__button showContainerDelivered__data__content__image__label__showImage__button--yellow"
  }, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1640062198",
    defaultMessage: "See"
  })), React.createElement("label", {
    htmlFor: "inputPhoto",
    className: "showContainerDelivered__data__content__image__label__showImage__button"
  }, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.3865020949",
    defaultMessage: "Take again"
  })))) : React.createElement("label", {
    htmlFor: "inputPhoto",
    className: "showContainerDelivered__data__content__image__label__showImage__button"
  }, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1288935685",
    defaultMessage: "Take photo"
  })), React.createElement("input", {
    type: "file",
    id: "inputPhoto",
    accept: "image/png, image/jpeg, image/jpg",
    capture: "camera",
    onChange: function onChange(e) {
      handleChangeImage(e, setPhotoError, setImageBlob, "".concat(slugify(tradeName), "-").concat(atob(orderId).split(":")[1], "-").concat(new Date().getTime(), ".").concat(e.target.files[0].name.split(".").pop()));
      setErrorsFields(errorsFields.filter(function (error) {
        return error.field !== ObligatoryFieldEnum.PAYMENT_CONFIRMATION_FILE;
      }));
    }
  }))), (errorsFields === null || errorsFields === void 0 ? void 0 : errorsFields.filter(function (error) {
    return error.field === ObligatoryFieldEnum.PAYMENT_CONFIRMATION_FILE;
  }).length) > 0 ? errorsFields === null || errorsFields === void 0 ? void 0 : errorsFields.filter(function (error) {
    return error.field === ObligatoryFieldEnum.PAYMENT_CONFIRMATION_FILE && error;
  }).map(function (error, index) {
    return React.createElement("p", {
      key: "".concat(error.field, "-").concat(index)
    }, error.message);
  }) : photoError && React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1237101747",
    defaultMessage: "The image must weight less than 4MB"
  }))))), React.createElement("div", {
    className: "showContainerDelivered__data__footer"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: hideModal
  }, delivered ? React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.2324218928",
    defaultMessage: "Close"
  }) : React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.2680335018",
    defaultMessage: "No"
  })), React.createElement(animated.button, {
    className: "showContainerDelivered__data__footer__p",
    type: "button",
    onClick: function onClick() {
      if (delivered && (paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id) === GatewayTypesEnum.DATAPHONE && obligatoryFielsData !== undefined && (obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : obligatoryFielsData.paymentConfirmationCode) && (confirmationCodeState === null || confirmationCodeState === void 0 ? void 0 : confirmationCodeState.trim()) === "") {
        setErrorsFields([{
          field: ObligatoryFieldEnum.PAYMENT_CONFIRMATION_CODE,
          message: intl.formatMessage(commonMessages.fieldRequired)
        }]);
        return;
      }

      if (delivered && (paymentMethodState === null || paymentMethodState === void 0 ? void 0 : paymentMethodState.id) === GatewayTypesEnum.DATAPHONE && obligatoryFielsData !== undefined && (obligatoryFielsData === null || obligatoryFielsData === void 0 ? void 0 : obligatoryFielsData.paymentConfirmationFile) && !imageBlob) {
        setErrorsFields([{
          field: ObligatoryFieldEnum.PAYMENT_CONFIRMATION_FILE,
          message: intl.formatMessage(commonMessages.fieldRequired)
        }]);
        return;
      }

      affirmativeAnswer();
    },
    style: scaleButton
  }, React.createElement("p", null, delivered ? React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.1464199760",
    defaultMessage: "Delivered"
  }) : React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryDecision.index.3308036799",
    defaultMessage: "Yes"
  }))))), showImage && React.createElement(AlertShowImage, {
    image: URL.createObjectURL(imageBlob),
    title: intl.formatMessage(commonMessages.voucher),
    hideModal: function hideModal() {
      return setShowImage(false);
    }
  }));
};
export default AlertDeliveryDecision;